module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  Tasks DETRO "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(this.pagination.totalItems))])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm"
  }, [_c('div', {
    staticClass: "panel panel-default wrapper-sm",
    attrs: {
      "id": "filters_main"
    }
  }, [_c('div', {
    staticClass: "row m-l-xs m-r-xs",
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroDataRegistro"
    }
  }, [_vm._v("Data de Registro")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataRegistro),
      expression: "filtros.dataRegistro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroDataRegistro"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "dataRegistro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Qualquer data\n                      ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Hoje'
    }
  }, [_vm._v("Hoje")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '7dias'
    }
  }, [_vm._v("Últimos 7 dias")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Mes'
    }
  }, [_vm._v("Este mês")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Ano'
    }
  }, [_vm._v("Este ano")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Periodo'
    }
  }, [_vm._v("Período")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroDataExecucao"
    }
  }, [_vm._v("Data de Execução")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataExecutado),
      expression: "filtros.dataExecutado"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroDataExecucao"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "dataExecutado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Qualquer data\n                      ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Hoje'
    }
  }, [_vm._v("Hoje")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '7dias'
    }
  }, [_vm._v("Últimos 7 dias")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Mes'
    }
  }, [_vm._v("Este mês")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Ano'
    }
  }, [_vm._v("Este ano")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Periodo'
    }
  }, [_vm._v("Período")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroStatus"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroStatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Todos\n                      ")]), _vm._v(" "), _vm._l((_vm.SITUACOES_TASK_LABEL), function(situacao, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(situacao.label) + "\n                      ")])
  })], 2)])])]), _vm._v(" "), (_vm.filtros.dataRegistro === 'Periodo') ? _c('div', {
    staticClass: "row m-l-xs m-r-xs"
  }, [_c('div', {
    staticClass: "col-md-6 filtros-periodo-datas form-group"
  }, [_c('span', {
    staticClass: "m-l m-r"
  }, [_vm._v("Registrado em ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataRegistro1),
      expression: "filtros.dataRegistro1"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroDataRegistro1",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.dataRegistro1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataRegistro1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "m-l m-r"
  }, [_vm._v("até")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataRegistro2),
      expression: "filtros.dataRegistro2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroDataRegistro2",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.dataRegistro2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataRegistro2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info m-l",
    attrs: {
      "disabled": !_vm.filtros.dataRegistro1 || !_vm.filtros.dataRegistro2
    },
    on: {
      "click": _vm.reloadData
    }
  }, [_vm._v("Pesquisar")])])]) : _vm._e(), _vm._v(" "), (_vm.filtros.dataExecutado === 'Periodo') ? _c('div', {
    staticClass: "row m-l-xs m-r-xs"
  }, [_c('div', {
    staticClass: "col-md-6 filtros-periodo-datas form-group"
  }, [_c('span', {
    staticClass: "m-l m-r"
  }, [_vm._v("Executado em ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataExecutado1),
      expression: "filtros.dataExecutado1"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroDataExecutado1",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.dataExecutado1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataExecutado1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "m-l m-r"
  }, [_vm._v("até")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.dataExecutado2),
      expression: "filtros.dataExecutado2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroDataExecutado2",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.dataExecutado2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "dataExecutado2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info m-l",
    attrs: {
      "disabled": !_vm.filtros.dataExecutado1 || !_vm.filtros.dataExecutado2
    },
    on: {
      "click": _vm.reloadData
    }
  }, [_vm._v("Pesquisar")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-sm-8 m-b-xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar: ID Task / Nº GRV / Placa / Chassi"
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-x": "unset"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedAll),
      expression: "checkedAll"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedAll) ? _vm._i(_vm.checkedAll, null) > -1 : (_vm.checkedAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedAll = $$c
        }
      }, function($event) {
        return _vm.checkAll(_vm.arrayData)
      }]
    }
  }), _c('i')])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('id')
      }
    }
  }, [_vm._v("\n                    ID Task "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'id'),
      expression: "filtros.sortBy === 'id'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Informações GRV")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('dateAdded')
      }
    }
  }, [_vm._v("\n                    Data de Registro "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'dateAdded'),
      expression: "filtros.sortBy === 'dateAdded'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('dateExecuted')
      }
    }
  }, [_vm._v("\n                    Data de Execução "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'dateExecuted'),
      expression: "filtros.sortBy === 'dateExecuted'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Opções")])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.arrayData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.selected),
        expression: "data.selected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "post[]",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(data.selected) ? _vm._i(data.selected, null) > -1 : (data.selected)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.lazyCheck(data)
        },
        "change": function($event) {
          var $$a = data.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(data, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(data, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(data, "selected", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v(_vm._s(data.id))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      staticStyle: {
        "white-space": "pre-wrap",
        "text-align": "left"
      },
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v(_vm._s(data.description))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      staticStyle: {
        "white-space": "pre-wrap",
        "text-align": "left"
      },
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v(_vm._s(_vm.formataInformacoesGrv(data)))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.dateAdded ? _vm.moment(data.dateAdded.date).format('DD/MM/YYYY HH:mm:ss') : '-----') + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.dateExecuted ? _vm.moment(data.dateExecuted.date).format('DD/MM/YYYY HH:mm:ss') : '-----') + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_c('span', {
      class: ("alert-" + (_vm.SITUACOES_TASK_LABEL[+data.executed].class)),
      staticStyle: {
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(_vm.SITUACOES_TASK_LABEL[+data.executed].label))])]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('btn-acoes-task', {
      attrs: {
        "task": data
      },
      on: {
        "forcarExecucaoTask": _vm.forcarExecucaoTask,
        "deleteTask": _vm.deleteTask
      }
    })], 1)])
  }), _vm._v(" "), (_vm.noData) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('footer', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 hidden-xs"
  }, [_vm._v("\n                  Mostrar:\n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination.limit),
      expression: "pagination.limit"
    }],
    staticClass: "input-sm form-control w-auto inline v-middle",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pagination, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.paginationLimits), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _vm._v("\n                  por página\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('small', {
    staticClass: "text-muted inline m-t-sm m-b-sm"
  }, [_vm._v(_vm._s(_vm.pagination.atualPage) + " / " + _vm._s(_vm.pagination.totalPages) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-right text-center-xs"
  }, [_c('u-pagination', {
    attrs: {
      "atual": _vm.pagination.atualPage,
      "total": _vm.pagination.totalPages
    },
    on: {
      "changePage": _vm.changePage
    }
  })], 1)])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd9f85b2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/tasks/components/ListaTasks.vue
// module id = 2099
// module chunks = 18